<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Drafts" pageTitle="Drafts" />
            <DraftsContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import DraftsContent from '../Drafts/DraftsContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'DraftsPage',
    components: {
        MainHeader,
        PageTitle,
        DraftsContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>